const InterfaceLanguageEnum = Object.freeze({
  Čeština: 'Jazyk rozhraní : ',
  Deutsch: 'Sprache : ',
  Français: "Langue de l'interface : ",
  Slovenčina: 'Jazyk rozhrania : ',
  Español: 'Idioma de la interfaz : ',
  English: 'Interface language : ',
})

export default InterfaceLanguageEnum
